import React, { useLayoutEffect } from 'react'  
import { CustomProvider as RSuiteCustomProvider } from 'rsuite'
import { Routes, Route } from 'react-router-dom'
import { cleanupStorage, initGTM } from '@revbox/helpers-fe'
import { datePickerLang } from '@revbox/localization'
import Main from './layouts/Main'
import NotFound from './pages/NotFound'
import { publicRoutes, iframeRoutes } from './routes/PublicRoutes'
import protectedRoutes from './routes/ProtectedRoutes'

import { Auth } from './components/Auth'
import { TrackUserActions } from './mixpanel/TrackUserActions'

import { usePublisherSetup } from './hooks/usePublisherSetup'
import { useNotifications } from './hooks/useNotifications'
import verifyIframeToken from './middleware/iframeAuth'
import { usePublisherStyles } from './hooks/usePublisherStyles'

export default function App() {
    const { language, publisher_id } = usePublisherSetup()
    const { setupNotifications } = useNotifications()

    useLayoutEffect(() => {
        initGTM()
        cleanupStorage('v2.0.5_since_2025-10-30')
        setupNotifications()

        return () => verifyIframeToken()
    }, [])

    usePublisherStyles(publisher_id)

    return (
        <RSuiteCustomProvider locale={datePickerLang[language]}>
            <TrackUserActions />
            <Routes>
                {iframeRoutes.map((route, index) => {
                    return <Route path={route.path} element={route.element} key={index} />
                })}
                {publicRoutes.map((route, index) => {
                    return <Route path={route.path} element={route.element} key={index} />
                })}
                <Route
                    path="/"
                    element={
                        <Auth>
                            <Main />
                        </Auth>
                    }
                >
                    {protectedRoutes.map((route, index) => {
                        return <Route path={route.path} element={route.element} key={index} />
                    })}
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </RSuiteCustomProvider>
    )
}
